import { CurrencyInput } from '@cimplico/components';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { isNullOrUndefined } from '../../new-workpaper/utils';
import Currency from '../../../components/currency/Currency';

type CreditFieldProps = {
    index: number;
    amountEditable: boolean;
    onPopulate: () => void;
};

function CreditField({ amountEditable, index, onPopulate }: CreditFieldProps): JSX.Element {
    const { control, setValue, getValues } = useFormContext();

    const credit = useWatch({ control, name: `lines.${index}.credit` });

    return (
        <>
            {amountEditable ? (
                <div className="mt-2.5">
                    <Controller
                        name={`lines.${index}.credit`}
                        control={control}
                        render={({ field: { onChange } }): JSX.Element => (
                            <CurrencyInput
                                size="small"
                                trailingText="Cr"
                                variant="underline"
                                value={isNullOrUndefined(credit) ? '' : credit.toString()}
                                onChange={(e): void => {
                                    onChange(e.target.value === '' ? null : e.target.value);
                                    setValue(`lines.${index}.debit`, null);
                                }}
                                onBlur={onPopulate}
                            />
                        )}
                    />
                </div>
            ) : (
                <div className="flex gap-2 text-xs justify-end pr-3 py-3">
                    {getValues(`lines.${index}.credit`) !== null ? (
                        <Currency
                            convertToHighestDenomination={false}
                            value={getValues(`lines.${index}.credit`)}
                            className="text-gray-800 font-medium"
                        />
                    ) : (
                        <div className="text-gray-800">-</div>
                    )}
                    <div className="text-gray-500">Cr</div>
                </div>
            )}
        </>
    );
}

export default CreditField;
